import {
  type FlowDefinitionState,
  FlowKind,
  type FlowPricingMode,
  type FlowState,
} from 'flow-schema';

import { type FlowDefinitionWithFlowBasic, type FlowTag } from './flowDefinition.js';
import { type BaseItem, type NullablePartial } from '../common.js';

export * as Admin from './admin.js';
export * as HumanTask from './humanTask/humanTask.js';

export const FlowKindProps: Record<FlowKind, { name: string }> = {
  [FlowKind.Base]: { name: 'Flow' },
  [FlowKind.Skill]: { name: 'Skill' },
  [FlowKind.FlowTemplate]: { name: 'Template' },
};

export interface BaseFlow {
  name: string;
  organizationId: string;
  agentId: string | null;
  state: FlowState;
  kind: FlowKind;
  description: string | null;
  createdById: string | null;
  updatedById: string | null;
  clonedFromFlowId?: string | null;
  pricingMode?: FlowPricingMode | null;
}

export interface Flow extends BaseFlow, BaseItem {}

export interface FlowWithCreatedBy extends Flow {
  createdByEmail: string | null | undefined;
  updatedByEmail: string | null | undefined;
  agentName: string | null;
  agentCategory: string | null;
  tags?: FlowTag[] | null;
}

export interface FlowWithRunCount extends FlowWithCreatedBy {
  runCount: number;
  mostRecentRunAt?: string;
  flowDefinitionStates?: FlowDefinitionState[];
}

export type CreateValues = NullablePartial<BaseFlow> & {
  tags?: FlowTag[] | null;
};

export type UpdateValues = Partial<Omit<CreateValues, 'createdById'>>;

export interface FlowWithDefinitions {
  flow: FlowWithCreatedBy;
  flowDefinitions: FlowDefinitionWithFlowBasic[];
}
